export default {
  list: (state) => {
    return state.list;
  },
  current_office: (state) => {
    return state.current_office;
  },
};
